import * as THREE from "three";
import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { GlitchPass } from "three/addons/postprocessing/GlitchPass.js";
import { OutputPass } from "three/addons/postprocessing/OutputPass.js";
import { Navbar } from "./Props";
import test500 from "./images/test/200.png";
import * as Fake from "@faker-js/faker";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { set } from "animejs";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db, storage } from "../firebase";
import { ref, getDownloadURL } from "firebase/storage";
import nullstatic from "./images/Static.gif";
export default function Contentlist() {
  let [search, setSearch] = useState("");
  let querypram = new URLSearchParams(window.location.search).get("q");
  window.onload = () => init();
  let camera,
    renderer,
    scene,
    clock,
    composer,
    spheremesh,
    spherelines,
    controls;
  function init() {
    const width = window.innerWidth,
      height = window.innerHeight;

    camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 10);
    camera.position.z = 5;

    scene = new THREE.Scene();
    const size = 200;
    const divisions = 250;
    //cant change remove and find alternative
    const gridHelper = new THREE.GridHelper(
      size,
      divisions,
      0xffffff,
      0xffffff
    );
    gridHelper.rotateX(-0.5 * Math.PI);

    scene.add(gridHelper);
    clock = new THREE.Clock();
    clock.start();
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);

    const spheregeo = new THREE.SphereGeometry(2.5, 20, 20);
    const spheremat = new THREE.MeshBasicMaterial({
      color: 0x000000,
    });

    const edges = new THREE.EdgesGeometry(spheregeo);
    const material = new THREE.LineBasicMaterial({
      color: 0x03fc07,
      transparent: true,
    });
    const spheregeo2 = new THREE.SphereGeometry(2.498, 20, 20);
    spherelines = new THREE.LineSegments(edges, material);
    spheremesh = new THREE.Mesh(spheregeo2, spheremat);
    console.log(spherelines);

    scene.add(spherelines);
    scene.add(spheremesh);

    composer = new EffectComposer(renderer);
    composer.addPass(new RenderPass(scene, camera));

    //const glitchPass = new GlitchPass();
    //composer.addPass(glitchPass)

    //glitchPass.goWild = true

    const outputPass = new OutputPass();
    composer.addPass(outputPass);
    window.addEventListener("resize", onWindowResize, false);
    appendWebglcon();
    animate();

    //controls = new OrbitControls(camera, renderer.domElement);
  }

  // animation
  function animate() {
    requestAnimationFrame(animate);
    const delta = clock.getDelta();
    spheremesh.rotation.y += delta / 19;
    spherelines.rotation.y += delta / 19;

    composer.render();
  }
  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    composer.setSize(window.innerWidth, window.innerHeight);
  }
  async function appendWebglcon() {
    document.getElementById("root").appendChild(renderer.domElement);
    renderer.domElement.classList.add("renderer-2nd");
    renderer.domElement.id = "webgl";
  }

  function List() {
    let list = [];
    let [projects, setProjects] = useState([]);

    if (search === "") {
      getDocs(collection(db, "Projects")).then((querySnapshot) => {
        setProjects(querySnapshot.docs.map((doc) => doc.data()));
      });
    } else {
      const q = query(
        collection(db, "Projects"),
        where("id", "==", parseInt(search))
      );
      getDocs(q).then((querySnapshot) => {
        setProjects(querySnapshot.docs.map((doc) => doc.data()));
      });
    }
    for (let index = 0; index < projects.length; index++) {
      const storageRef2 = ref(
        storage,
        "Content/" + projects[index].id + "/Foreground.png"
      );
      getDownloadURL(storageRef2)
        .then((url) => {
          const img = document.getElementById(
            "Foreground" + projects[index].id
          );
          img.setAttribute("src", url);
        })
        .catch((error) => {
          console.log(error);
        });

      list.push(
        <li>
          <a
            href={
              "/content?id=" + projects[index].id + "&Backtocontentlisting=true"
            }
          >
            <div>
              <img
                id={"Foreground" + projects[index].id}
                src={nullstatic}
                alt="test500"
              />
            </div>
          </a>
        </li>
      );
    }

    return <ul>{list}</ul>;
  }

  return (
    <>
      <Navbar fixed="true"></Navbar>
      <div className="coverpage disablescroll">
        <div className="contentlist centerelements">
          <div className="mainlist">
            <div className="search centerelements">
              <h1>Directory Search</h1>
              <form className="centerelements">
                <input
                  type="text"
                  placeholder="QUERY"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </form>
            </div>
            <div className="list">
              <List></List>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
